import { Component, Inject } from '@angular/core';

import {OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { EventBusService } from '../../../services/event-bus.service';
import { BatchService } from '../../../services/batch.services';
import { MedicineService } from '../../../services/medicine.services';
import { MessageService } from '../../../services/message.service';

import * as moment from 'moment';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { PrintService } from 'src/services/print.service';
import { AlertComponent } from 'src/components/alert/alert.component';

@Component({
  selector: 'rm-unique-product-label-dialog',
  templateUrl: './unique-product-label.component.html',
  styleUrls: ['./unique-product-label.component.css']
})
export class UniqueProductLabelDialogComponent implements OnInit {
  
  subscriptions: any[] = [];
  products: any;
  gcp: string;
  selectedProduct: any;
  success: boolean = false;
  printCount: number = 1;

  labelImg: string = '';
  hri: any;
  labels: any[] = [];
  formats: any[];
  selectedFormat: string;

  locations: any;
  selectedLocation: any;

  constructor(
    private dialogRef: MatDialogRef<UniqueProductLabelDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private batchService: BatchService,
    private medicineService: MedicineService,
    private msgService: MessageService,
    private ebService: EventBusService,
    private globalCfgService: GlobalCfgService,
    private printService: PrintService,
    private dialog: MatDialog,
  ) {
  }

  ngOnInit() {
    if (!this.gcp) {
        this.gcp = this.globalCfgService.getGcp();
    }
    this.subscriptions.push(this.ebService.locationsListValue$.subscribe(
      (list)=> this.locations = list
    ));

    this.ebService.loadLocationsList(this.gcp);
    this.loadFormats();
  }

  loadProducts(e) {
    this.medicineService.getListByLocation({
      gcp: this.gcp,
      gln: e.value}).subscribe((response: any) => {
      this.products = response;
      if (this.products.length > 0) {
        this.selectedProduct = this.products[0].gtin;
      }
    });
  }

  cancel() {
      this.dialogRef.close();
  }

  generateLabel() {
      console.log('generate label: ', this.selectedProduct);
      var type = this.data.type ? this.data.type : 'il';
      var rec = {
        gtin: this.selectedProduct,
        serializationType: type,
        countryCode: '',
        mfgDate: moment().format('YYYY-MM-DD'),
        expiryDate: moment().add(5, 'days').format('YYYY-MM-DD'),
        batchQuantity: 1,
        mfgTemperature: "",
        mfgHumidity: "",
        isNotForSale: false,
        gs1ApplicationIdentifiers: "[packageIndicator,gtin,batchNo,productionDate,serialNo]",
        flags: {
          isSendCodeInResponse: false,
          isTempSensitive: false,
          isMoistureSensitive: false,
          isLocationTrackingOn: false,
          isLightExposureMonitoringOn: false,
          isShockMonitoringOn: false
        }
      };

      this.batchService.add(rec).subscribe(
        (response: any)=> {
          if (response.status) {
            this.success = true;
            this.labelImg = 'data:image/png;base64,' + response.label[0].code;
            this.hri = response.label[0].hri;
          } else {
              this.msgService.showError(this.msgService.labelsCreateFail);
          }
        }
      );
  }

  loadFormats() {
    this.printService.getPrintFormats().subscribe(
      (result: any)=> {
        this.formats = result['data'];
      });
  }

  print(format) {
    if (!format) {
      const dialogRef = this.dialog.open(AlertComponent, {
        width: "450px",
        data: { 
          note: "Please select a print format before printing",
        },
      });

      return;
    }
    if (this.labels.length > 0) {
      this.labels = [];
    }
    var obj = {
      img: this.labelImg,
      hri: this.hri
    };
    for (var i = 0; i < this.printCount; i++) {
      this.labels.push(obj);
    }
    var printWin = window.open('', 'new div', 'height=400,width=600');
    var htmlStr = this.printService.getHtmlStr(format, this.labels);

    console.log(htmlStr);

    printWin.document.write(htmlStr);
    printWin.print();
    // printWin.close();

    // this.dialogRef.close();
  }
}